<template>
<div class="wrapper">
  <parallax class="page-header header-filter" :style="headerStyle">

    <div class="md-layout">
      <div class="md-layout-item mx-auto text-center">
        <div class="brand">
          <h1>JSBoards</h1>
          <h3>Gallery</h3>
        </div>

      </div>
    </div>
  </parallax>
  <div class="main main-raised">
    <div class="md-layout-item md-size-50 mx-auto md-medium-size-100">
      <md-card id="gallery">
        <lingallery :addons="{ enableLargeView: true}" :iid.sync="board1" :width="width" :height="height" :items="items" />
      </md-card>

      <!-- <div id="gallery2">
        <img class="image" v-for="(image, i) in images" :src="image" :key="i" @click="index = i">
        <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
      </div> -->
    </div>
  </div>
</div>
</template>

<script>
import Lingallery from 'lingallery';

import board1 from "@/assets/img/board1-GPX-yellow-52.jpg";
import board2 from "@/assets/img/board2-GPX-blue-white-52.jpg";
import board3 from "@/assets/img/board3-GPX-green-52.jpg";
import board4 from "@/assets/img/board4-GLX-turqoise-54.jpg";
import board5 from "@/assets/img/board5-GLX-pink-49.jpg";
import board6 from "@/assets/img/board6-GLX-purple-49.jpg";

import board1thumb from "@/assets/img/board1-GPX-yellow-52-thumb.jpg";
import board2thumb from "@/assets/img/board2-GPX-blue-white-52-thumb.jpg";
import board3thumb from "@/assets/img/board3-GPX-green-52-thumb.jpg";
import board4thumb from "@/assets/img/board4-GLX-turqoise-54-thumb.jpg";
import board5thumb from "@/assets/img/board5-GLX-pink-49-thumb.jpg";
import board6thumb from "@/assets/img/board6-GLX-purple-49-thumb.jpg";

export default {
  name: "gallery",
  bodyClass: "gallery-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/backgroundOpaque.jpg")
    }
  },
  mounted() {
  },
  data() {
    return {
      width: 1024,
      height: 768,
      responsive: true,
      items: [
        {
          src: board1,
          thumbnail: board1thumb,
          caption: 'GPX Yellow 52inch',
          id: 'board1'
        },
        {
          src: board2,
          thumbnail: board2thumb,
          caption: 'GPX Blue-White 52inch',
          id: 'board2'
        },
        {
          src: board3,
          thumbnail: board3thumb,
          caption: 'GPX Green 52inch',
          id: 'board3'
        },
        {
          src: board4,
          thumbnail: board4thumb,
          caption: 'GLX Turqoise 54inch',
          id: 'board4'
        },
        {
          src: board5,
          thumbnail: board5thumb,
          caption: 'GLX Pink 49inch',
          id: 'board5'
        },
        {
          src: board6,
          thumbnail: board6thumb,
          caption: 'GPX Purple 49inch',
          id: 'board6'
        }
      ]
    };
  },
  components: {
    Lingallery
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`
      };
    },
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`
      };
    },
  }
};
</script>
<style lang="scss" scoped>
.section-download {
    .md-button + .md-button {
        margin-left: 5px;
    }
}

@media all and (min-width: 991px) {
    .btn-container {
        display: flex;
    }
}

@media (max-width: 768px) {
    .footer {
        nav {
            display: block;
        }
    }

    .brand h1 {
        font-size: 4.3rem;
    }

    .brand h3 {
        display: inline-block;
        max-width: 500px;
        line-height: 1;
        font-size: 1.7rem;
    }
}
</style>
